module.exports = __webpack_public_path__ + "img/question.c0e36af8.jpg";